import axios from 'axios';

export default {
    name: 'asset-location',
    data() {
        return {
            auth: this.$parent.auth,
            selectedAssetLocation: this.$parent.selectedAssetLocation,
            selectedPropertyName: this.$parent.propertyName,
            selectedAssets: [],
            locationAssets: [],
            locationAssetHeaders: [
                { name: 'section.name', label: this.$t('HC_SECTION') },
                { name: 'type.name', label: this.$t('HC_NAME') },
                { name: 'type.brand', label: this.$t('HC_BRAND') },
                { name: 'type.model', label: this.$t('HC_MODEL') },
                { name: 'serialNumber', label: this.$t('HC_SERIAL') },
                { name: 'other', label: this.$t('HC_OTHER') },
                { name: 'condition', label: this.$t('HC_CONDITION') }
            ],
            historyStack: [
                { name: 'Assets', view: 'assets' },
                { name: this.$parent.selectedAssetLocation.name, url: '#' }
            ],
            searchQuery: '',
            actions: [{ name: 'View' }, { name: 'Order' }],
            pageLength: 0, // Compared with selectedAssets to determine what message to display on the toast
            isToastVisible: false
        };
    },
    created() {
        axios
            .get(
                this.auth.v4.url +
                    `/areas/${
                        this.selectedAssetLocation.id
                    }/items?expand=type,section&fields=id,typeId,areaId,sectionId,serialNumber,other,workOrderCount,completedWorkOrderCount`,
                {
                    headers: {
                        'x-api-key': this.auth.v4.token
                    }
                }
            )
            .then(result => {
                let results = result.data.data;

                results.forEach(item => {
                    if (item.workOrderCount === 0) {
                        item.condition = this.$t('HC_PERFECT');
                    } else if (
                        item.workOrderCount === item.completedWorkOrderCount
                    ) {
                        item.condition = this.$t('HC_GOOD');
                    } else {
                        item.condition = this.$t('HC_NEEDS_IMPROVEMENT');
                    }
                });

                this.locationAssets = results;
            });
    },
    methods: {
        // handleActionClick(item, action) {
        //     // view/order link actions here
        // },
        // deleteAsset(assetIds) {
        //     // delete action here
        // },
        // Only show the toast when the "select all" checkbox was clicked
        showToast(event) {
            this.pageLength = this.selectedAssets.length;
            this.isToastVisible = event;
        }
    },
    watch: {
        searchQuery() {
            this.isToastVisible = false;
        }
    }
};
